import { Box, withStyles } from '@material-ui/core';

export const Container = withStyles(({ palette, spacing }) => ({
  root: {
    padding: 8,
    borderRadius: 8,
    backgroundColor: palette.common.white,
    display: 'flex',
    gap: spacing(2),
    borderBottom: '1px solid #EEF0F2',
    height: 'fit-content'
  }
}))(Box);

export const ImageWrapper = withStyles(() => ({
  root: {
    width: 88,
    height: 76,
    borderRadius: 4,
    overflow: 'hidden',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  }
}))(Box);
